import React, { useEffect, useState } from "react";
import styles from "./styles/generate-music-button.module.scss";
import FilledButton from "@/components/common/filled-button";
import { useStartTextToMusic } from "@/components/pages/text-to-music/hooks/use-start-text-to-music";
import { useTextToMusicContext } from "@/components/pages/text-to-music/components/providers/text-to-music-provider";
import Loader from "@/components/common/loader";
import CoverTooltip from "@/components/pages/convert/components/cover-tooltip";

const GenerateMusicButton = () => {
  const [textInput, setTextInput] = useState<string>("");
  const [trackLength, setTrackLength] = useState<number>(0);
  const [isActive, setIsActive] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const { startTextToMusic } = useStartTextToMusic();
  const { settings } = useTextToMusicContext();

  useEffect(() => {
    setTextInput(settings.text);
    setTrackLength(settings.trackLength);
  }, [settings.text, settings.trackLength]);

  const handleTtmClick = async () => {
    setIsLoading(true);
    try {
      await startTextToMusic({ text: textInput, trackLength: trackLength });
    } catch (error) {
      console.error("Generation error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const isActive = textInput !== undefined && settings.text?.length !== 0;
    setIsActive(isActive);
  }, [textInput, settings.text]);

  return (
    <div
      className={styles.wrapper}
      data-tooltip-id="ttmTooltip"
      data-tooltip-content="Please describe the music you want to generate"
    >
      {isLoading ? (
        <Loader size={"48px"} />
      ) : (
        <>
          <FilledButton
            text={"Generate Music"}
            onClick={handleTtmClick}
            textTransform={"uppercase"}
            backgroundColor={"#ff5722"}
            disabled={!isActive}
          />
          <CoverTooltip id="ttmTooltip" />
        </>
      )}
    </div>
  );
};

export default GenerateMusicButton;
